export default __webpack_public_path__ + "static/media/83_desktop.0728d6a3.jpg";